// Scope node types. The organization itself is the "tenant" node at the root.
export enum EAccessScope {
  ORGANIZATION = "tenant",
  BRANCH = "branch",
  SITE = "site",
}
